<ifc-app-scroll-container>
  <div class="wrapper">
    <header class="header">
      <h1 class="header__title mat-headline-5">{{(data$ | async)?.greetings}}</h1>
      <button mat-flat-button
              class="header__cta"
              color="primary"
              [routerLink]="WebPaths.NewSubmission">
        + NEW SUBMISSION
      </button>
    </header>
    <section class="snapshot">
      <ifbp-dashboard-filter-bar class="snapshot__filter-bar"
                                 [asOfUtc]="(snapshot$ | async)?.asOfUtc ?? null">
      </ifbp-dashboard-filter-bar>
      <ng-container *ngIf="snapshot$ | async as snapshot"
                    [ngSwitch]="snapshot.state">
        <ifbp-snapshot-skeleton *ngSwitchCase="SnapshotState.LOADING">
        </ifbp-snapshot-skeleton>
        <ifbp-snapshot-error-card *ngSwitchCase="SnapshotState.ERROR"
                                  [message]="snapshot.errorMessage"
                                  fallbackMessage="Your snapshot is unavailable right now. Change the period or scope to try again.">
        </ifbp-snapshot-error-card>
        <ng-container *ngSwitchCase="SnapshotState.DATA">
          <ifbp-inactivity-panel *ngIf="snapshot.data?.inactivityPanel"
                                 [vm]="snapshot.data.inactivityPanel">
          </ifbp-inactivity-panel>
          <ifbp-snapshot-tiles [tiles]="snapshot.data?.tiles"
                               [fundedLabel]="snapshot.data?.fundedTileLabel">
          </ifbp-snapshot-tiles>
          <ifbp-funded-hero-card [periodTitle]="snapshot.data?.periodTitle"
                                 [funded]="snapshot.data?.funded"
                                 [paceLine]="snapshot.data?.paceLine">
          </ifbp-funded-hero-card>
          <ifbp-requiring-action-list [rows]="snapshot.data?.rows"
                                      [showViewAll]="snapshot.data?.showViewAll"
                                      [viewAllQuery]="snapshot.data?.viewAllQuery">
          </ifbp-requiring-action-list>
        </ng-container>
      </ng-container>
    </section>
    <!-- Figma 15255:29475: the feedback card beside the advisor block. Main-content widgets
         (release notes, the testing-environment notice) are no longer rendered on this page. -->
    <section class="content"
             *ngIf="data$ | async as data">
      <ifbp-dashboard-widget class="content__widget"
                             *ngFor="let widgetData of data?.widgetsData?.asideWidgets; trackBy: trackByWidget"
                             [data]="widgetData">
      </ifbp-dashboard-widget>
      <ifbp-advisor-widget class="content__advisor"
                           callIconName="add_ic_call"
                           [data]="data.advisorData">
      </ifbp-advisor-widget>
    </section>
  </div>
</ifc-app-scroll-container>
